export const ru = {
    'apply-recommendation-error':
        'При применении рекомендации возникла ошибка. Попробуйте еще раз',
    bannerAimingFailed:
        'Что-то пошло не так. Попробуйте нацелиться еще раз позже.',
    bannerAimingSuccessful:
        'Нацеливание прошло успешно. У Вас есть 10 минут, чтобы посмотреть объявление.',
    'client-campaigns': 'Кампании клиента',
    'failed-to-load-banners-for-popup':
        'Не удалось загрузить баннеры. Попробуйте еще раз',
    'fetch-moderation-reject-reasons-error':
        'Не удалось получить причины отклонения. Попробуйте еще раз',
    'link-message-groups': 'Посмотреть',
    'mass-actions-server-error': 'Произошла ошибка. Перезагрузите страницу.',
    'my-campaigns': 'Мои кампании',
    operationError: 'Во время выполнения операции копирования произошла ошибка',
    'pay-not-allowed-cpm':
        'Для оплаты медийных кампаний необходимо выставить отдельный счет. Оплата вместе с другими кампаниями недоступна.',
    'pay-not-allowed-deals':
        'Для оплаты кампаний со сделками необходимо выставить отдельный счет. Оплата вместе с кампаниями без сделок недоступна.',
    'pay-will-not-apply-for-campaigns':
        'Выбранное действие недоступно для кампаний: {campaignsIds}',
    'phrase-1': 'фразы',
    'phrase-2': 'фраз',
    'phrase-5': 'фраз',
    'popup-save-success': 'Изменения успешно сохранены',
    'search-and-replace-success':
        'Замена произведена в {updatedTotalCount} из {selectedCount} {phraseWord}',
    'search-and-replace-success-with-yt-limit':
        'Через несколько секунд будут изменены {phrasesCount} фраз. Чтобы заменить остальные фразы, отфильтруйте их и повторите действие.',
    'try-later':
        'При применении рекомендации возникла ошибка. Попробуйте еще раз'
};
